module.exports = __webpack_public_path__ + "9e4f913fb70d77b2898dd935c62b626a.ttf";